import React, { useContext, useEffect, useState } from 'react';
import { List, Tag, Space } from 'antd';
import {
	CheckCircleOutlined,
	ExclamationCircleOutlined,
	ClockCircleOutlined,
} from '@ant-design/icons';
import { BiArrowBack } from 'react-icons/bi';
import moment from 'moment';
import 'moment/locale/en-in';
import filterContext from '../context/filters/filterContext';
// import { apiBaseUrl } from 'utils/config';
import '../components/Common/roundedButton.css';
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
function RedFlagResolution() {
	const {
		usersOfParticularGroup,
		setIsLoading,
		convId,
		setShowRedFlagResolution,
	} = useContext(filterContext);
	const [redHistory, setRedFlagHistory] = useState([]);

	useEffect(() => {
		getREedFlagHistory(convId);
	}, []);
	const getREedFlagHistory = async convId => {
		try {
			const response = await fetch(
				`${apiBaseUrl}/chats/get-red-flag-history?conversationId=${convId}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						authorization: `Token ${window.localStorage.getItem('token')}`,
					},
				}
			);
			const data = await response.json();
			// setConversationdata(data.conversations); //this point
			setRedFlagHistory(data.messages);
			// console.log(data.conversations);
			setIsLoading(false);
		} catch (error) {
			console.log('Some error occurred');
		}
	};
	const filteredMessages = redHistory.filter(
		message =>
			(message.isRedFlag && message.remark === '') ||
			(!message.isRedFlag && message.remark !== '')
	);

	const handleToggleRedFlagResolution = () => {
		setShowRedFlagResolution(prevState => !prevState);
	};

	// const callItForGrp = async (param) => {
	// 	// console.log('called');

	// 	const response = await fetch(
	// 		`${apiBaseUrl}/chats/getUsersOfBatches?${param}`,
	// 		{
	// 			method: 'GET',
	// 			headers: {
	// 				'Content-Type': 'application/json',
	// 				authorization: `Token ${window.localStorage.getItem('token')}`,
	// 			},
	// 		}
	// 	)
	// 		.then(response => response.json())
	// 		.then(data => {
	// 			if (data.success) {
	// 				// API call succeeded, update UI accordingly
	// 				console.log('success');
	// 			} else {
	// 				// API call failed, handle the error
	// 				console.error('Error marking/unmarking message as red flag:', data.msg);
	// 			}
	// 		})
	// 		.catch(error => {
	// 			console.error('Error marking/unmarking message as red flag:', error);
	// 		});
	// };
	// const dataParam = [
	// 	"std[]=12%20Science&schoolName[]=Nirman%20Vastrapur&board[]=GSEB",
	// 	"std[]=11%20Science&schoolName[]=St.%20Xavier'S%20High%20School%20Loyola%20Hall&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=St.%20Xavier'S%20High%20School%20Loyola%20Hall&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=St.%20Xavier'S%20High%20School%20Loyola%20Hall&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=St.%20Xavier'S%20High%20School%20Loyola%20Hall&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Oxford%20English%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Oxford%20English%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Oxford%20English%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Oxford%20English%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Dav%20International%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Dav%20International%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Dav%20International%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Dav%20International%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Shanti%20Asiatic%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Shanti%20Asiatic%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Shanti%20Asiatic%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Shanti%20Asiatic%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Shreyas%20Foundation&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Shreyas%20Foundation&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Shreyas%20Foundation&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Shreyas%20Foundation&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Delhi%20Public%20School%20-%20Dps%20(South%20Bopal)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Delhi%20Public%20School%20-%20Dps%20(South%20Bopal)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Delhi%20Public%20School%20-%20Dps%20(South%20Bopal)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Delhi%20Public%20School%20-%20Dps%20(South%20Bopal)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Kendriya%20Vidhlaya%20(Sac)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Kendriya%20Vidhlaya%20(Sac)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Kendriya%20Vidhlaya%20(Sac)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Kendriya%20Vidhlaya%20(Sac)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Maharaja%20Agrasen%20Vidyalaya&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Maharaja%20Agrasen%20Vidyalaya&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Maharaja%20Agrasen%20Vidyalaya&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Maharaja%20Agrasen%20Vidyalaya&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Crescent&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Crescent&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Crescent&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Crescent&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=G.L.S.&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=G.L.S.&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=G.L.S.&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=G.L.S.&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=The%20New%20Tulip%20International%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=The%20New%20Tulip%20International%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=The%20New%20Tulip%20International%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=The%20New%20Tulip%20International%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Divya%20Joyt&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Divya%20Joyt&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Divya%20Joyt&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Divya%20Joyt&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Shree%20Narayana%20Guru%20Vidhyalaya%20(Sngv)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Shree%20Narayana%20Guru%20Vidhyalaya%20(Sngv)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Shree%20Narayana%20Guru%20Vidhyalaya%20(Sngv)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Shree%20Narayana%20Guru%20Vidhyalaya%20(Sngv)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Navchetan%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Navchetan%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Navchetan%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Navchetan%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Little%20Flower%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Little%20Flower%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Little%20Flower%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Little%20Flower%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=F.D.%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=F.D.%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=F.D.%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=F.D.%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Divine%20Buds%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Divine%20Buds%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Divine%20Buds%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Divine%20Buds%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=St.%20Xavier%20Mirzapur&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=St.%20Xavier%20Mirzapur&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=St.%20Xavier%20Mirzapur&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=St.%20Xavier%20Mirzapur&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Divine%20Life%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Divine%20Life%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Divine%20Life%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Divine%20Life%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Sharadamandir&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Sharadamandir&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Sharadamandir&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Sharadamandir&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Zebar%20School%20For%20Children&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Zebar%20School%20For%20Children&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Zebar%20School%20For%20Children&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Zebar%20School%20For%20Children&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Ankur&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Ankur&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Ankur&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Ankur&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Prakash%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Prakash%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Prakash%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Prakash%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Udgam&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Udgam&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Udgam&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Udgam&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Cosmos%20Castle%20International%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Cosmos%20Castle%20International%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Cosmos%20Castle%20International%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Cosmos%20Castle%20International%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Zydus&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Zydus&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Zydus&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Zydus&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Sri%20Sri%20Ravishankar%20Vidya%20Mandir%20(Ssrvm)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Sri%20Sri%20Ravishankar%20Vidya%20Mandir%20(Ssrvm)&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=Sri%20Sri%20Ravishankar%20Vidya%20Mandir%20(Ssrvm)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=Sri%20Sri%20Ravishankar%20Vidya%20Mandir%20(Ssrvm)&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=St.%20Ann'S%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=St.%20Ann'S%20High%20School&board[]=CBSE&queryPhase[]=Prahladnagar",
	// 	"std[]=11%20Science&schoolName[]=St.%20Ann'S%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar",
	// 	"std[]=12%20Science&schoolName[]=St.%20Ann'S%20High%20School&board[]=GSEB&queryPhase[]=Prahladnagar"
	// ]
	// for (let i = 0; i < dataParam.length; i++) {
	// 	callItForGrp(dataParam[i]);
	// 	console.log("callec")
	// }

	return (
		<div style={{ paddingBottom: '100px' }}>
			<div style={{ padding: '20px' }}>
				<div>
					<button
						style={{
							backgroundColor: '#202d33',
							color: 'white',
							fontSize: '20px',
							padding: '0.5rem',
							borderRadius: '50%',
							border: 'none',
							lineHeight: 'normal',
						}}
						onClick={handleToggleRedFlagResolution}
					>
						<BiArrowBack />
					</button>
				</div>
				<div>
					<h1 style={{ color: 'white', textAlign: 'center' }}>
						Red Flag Resolution
					</h1>
				</div>
			</div>
			<List
				itemLayout="vertical"
				dataSource={filteredMessages}
				renderItem={(message, index) => (
					<List.Item
						key={index}
						style={{
							background: message.isRedFlag ? 'none' : 'none',
							color: 'white',
							padding: '25px',
							paddingLeft: '25px',
							display: 'flex',
							justifyContent: 'space-between',
						}}
					>
						<div style={{ flex: '1' }}>
							<span style={{ color: 'white' }}>
								{index + 1}. Message: {message.text}
							</span>
							<div>
								<span style={{ color: 'white', marginLeft: '16px' }}>
									Time:{' '}
									{moment(message.createdAt)
										.locale('en-in')
										.format('DD MMMM h:mm A')}
								</span>
							</div>
							<div>
								<span style={{ color: 'white', marginLeft: '16px' }}>
									Raised By: {message.raisedBy.name}
								</span>
							</div>
							{message.resolvedBy ? (
								<div>
									<span style={{ color: 'white', marginLeft: '16px' }}>
										Resolved By: {message.resolvedBy.name}
									</span>
								</div>
							) : null}
						</div>
						<Space>
							{message.isRedFlag ? (
								<Tag icon={<ExclamationCircleOutlined />} color="error">
									Red Flag Active
								</Tag>
							) : (
								<Tag icon={<CheckCircleOutlined />} color="success">
									Red Flag Solved with Remark
								</Tag>
							)}
							{message.isRedFlag ? (
								<Tag icon={<ClockCircleOutlined />} color="warning">
									Remark is Pending
								</Tag>
							) : (
								<Tag>{message.remark}</Tag>
							)}
						</Space>
					</List.Item>
				)}
			/>
		</div>
	);
}

export default RedFlagResolution;
